<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'
import {useAppStore} from '@/stores/appStore'
import {useNavigationStore} from '@/stores/navigation'
import NavigationGroup from './NavigationGroup.vue'
import NavigationMobile from './NavigationMobile.vue'
import NavigationSupportBtn from './NavigationSupportBtn.vue'
import NavigationPreviewBtn from './NavigationPreviewBtn.vue'
import NotificationsMenu from '@/common/notifications-menu/NotificationsMenu.vue'
import NavigationUserMenu from './NavigationUserMenu.vue'
import Button from '@/common/Button.vue'
import AiDashboard from "@/components/ai-dashboard/AiDashboard.vue"

const router = useRouter()
const navigationStore = useNavigationStore()
const appStore = useAppStore()

const navigationGroups = computed(() => navigationStore.groups)
const aiMode = computed(() => appStore.aiMode)
</script>

<template>
    <nav v-if="navigationGroups.length" class="d-flex align-items-stretch border-bottom" role="navigation">
        <div class="d-flex align-items-center">
            <Button @click="router.push({ name: 'dashboard' })" class="px-3 rounded-0 h-100">
                <img src="/creativecms-logo-icons.png" alt="Go to dashboard" style="width: 40px">
            </Button>
        </div>

        <NavigationMobile/>

        <div class="d-none d-md-flex flex-fill">
            <NavigationGroup v-for="(groupName, index) in navigationGroups" :key="index" :group-name="groupName"/>
        </div>

        <div class="d-flex align-items-stretch">
            <NavigationSupportBtn/>
            <NavigationPreviewBtn/>
            <NotificationsMenu/>
            <AiDashboard v-if="aiMode"/>
            <NavigationUserMenu/>
        </div>
    </nav>
</template>